// extracted by mini-css-extract-plugin
module.exports = {"root":"separator_root__uo4FM"};